import { useQuery } from '@tanstack/react-query';
import { useQueryState } from 'nuqs';
import { useCallback, useMemo } from 'react';

import {
  asStringList,
  CAPACITY_FILTER_KEYS,
  sortReleasesNewestFirst
} from '../utils/capacityFilters';
import { runFiltersParser } from '../utils/runFilters';

import apiRun from '~/api/runtime';

export const ENGINE_VERSIONS_STALE_TIME = 15 * 1000;

export const useDeploymentEngineVersions = (
  realm: string,
  environment: string
) => {
  const isReady = !!realm && !!environment;
  const [filters] = useQueryState('filters', runFiltersParser);
  const selected = filters?.[CAPACITY_FILTER_KEYS.engineVersion];

  const { data, isStale, refetch } = useQuery({
    queryKey: ['run', 'deployment-engine-versions', realm, environment],
    queryFn: (): Promise<string[]> =>
      apiRun.getDeploymentEngineVersions({ realm, environment }),
    enabled: isReady,
    staleTime: ENGINE_VERSIONS_STALE_TIME
  });

  const options = useMemo(
    () =>
      sortReleasesNewestFirst([...(data ?? []), ...asStringList(selected)]).map(
        version => ({ value: version, label: version })
      ),
    [data, selected]
  );

  const refresh = useCallback(() => {
    if (isReady && isStale) refetch();
  }, [isReady, isStale, refetch]);

  return { options, refresh };
};
